import { getTenantId } from 'common/helpers/apiHelper';

export const productTeam = [
  'development',
  'yalcin-sandbox-account',
  'noah-sandbox-account',
  'andreas-demo-winery',
  'jason-demo-site',
  'jason-demo-site-db4',
  'sandbox-c7-development-josh',
  'commerce7development',
  'joshsandbox',
  'peter-sandbox-account',
  'sandbox-yves',
  'test-tenant-id',
  'yalcindigitalwallet',
  'andrew-carpenter-sandbox'
];

const AToD = ['a', 'b', 'c', 'd'];
const EToL = ['e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'];
const MToZ = [
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z'
];
const fullSteamWalletTestGroup = [
  'sandbox-fullsteam-payments-testing',
  'sandbox-fullsteam-payments-testing-prod-env',
  'sandbox-fullsteam-payments-testing-dev-env',
  'spectra-winery-demo-v2',
  'alicias-test-account',
  'matt-jensen-sandbox-account',
  'sandbox-britney',
  'robert-ziraldo-sandbox-account',
  'colin-s-sandbox',
  'dan-demo-tenant',
  'britney-demo-account'
];
const fullSteamWalletBetaTenants = ['bingham-family-cellars'];

const isOpusWineryGroup = [
  'opus-one-winery',
  'opus-one-japanese',
  'opus-one-chinese',
  'opus-one-winery',
  'opus-one-international-english',
  'opus-one-testing',
  'opus-one-payment-testing'
];

export const isDarioush = () => {
  const tenants = ['darioush', 'staging-darioush', 'staging-2-darioush'];
  if (tenants.includes(getTenantId())) {
    return true;
  }
  return false;
};

export const hasNewBillingCompliance = () => {
  const firstLetter = getTenantId().charAt(0);
  if (productTeam.includes(getTenantId())) {
    return true;
  }
  if (AToD.includes(firstLetter)) return true;
  if (EToL.includes(firstLetter)) return true;
  if (MToZ.includes(firstLetter)) return true;
  return false;
};

export const isTestFullSteamDigitalWallet = () => {
  if (
    productTeam.includes(getTenantId()) ||
    fullSteamWalletTestGroup.includes(getTenantId())
  ) {
    return true;
  }
  return false;
};

export const isTestFullSteamDigitalWalletForBetaCustomers = () => {
  if (fullSteamWalletBetaTenants.includes(getTenantId())) {
    return true;
  }
  return true;
};

// // This feature flag allows our team to test/demo Commerce7 Payments in Dev mode
export const isCommerce7DigitalWalletDevMode = (tenantId) => {
  const allowedTenants = [
    'commerce7development',
    'yalcindigitalwallet',
    'sandbox-fullsteam-payments-testing-dev-env'
  ];
  if (allowedTenants.includes(tenantId)) {
    return true;
  }
  return false;
};

export const hasForterTokenCookie = () => {
  if (
    productTeam.includes(getTenantId()) ||
    isOpusWineryGroup.includes(getTenantId())
  ) {
    return true;
  }
  return false;
};
